import React from 'react'

import DecommissionCashRegister from './DecommissionCashRegister'
import ReactivateCashRegister from './ReactivateCashRegister'

const ToggleCashRegisterState = props => {
	if(props?.data?.outOfOrder) {
		return <ReactivateCashRegister {...props} />
	}

	return <DecommissionCashRegister {...props} />
}

export default ToggleCashRegisterState
